import { LebeledInput } from "./lib/LabeledInput.js"
import { AddressHelper } from "./AddressHelper.js"
import { I18N } from "./I18N.js"
import { DateHelper } from "./lib/DateHelper.js"
import { OrderSchedule } from "./OrderSchedule.js"

export class StoreSearch {
	_target
	_collapsed = true
	_orderSchedule
	_onSetFilterHandlers = []
	_stores
	_schedule

	/**
	 * 
	 * @param {String} target The id of the target element
	 */
	constructor(target) {
		this._target = document.getElementById(target)
		this._target.classList.add('collapsable')
		this._target.classList.add('collapsed')
		this._setLocalStorageDelivery(this._isLocalStorageDelivery())
		if (!localStorage.getItem('filterDeliveryCountry')) {
			localStorage.setItem('filterDeliveryCountry', 'DE')
		}
		this._target.innerHTML = `
		<button id="filterExpandBtn" class="toggleBtn expand primary"><span class="material-icons-outlined">expand_more</span></button>
		<button id="filterCollapseBtn" class="toggleBtn collapse"><span class="material-icons-outlined">expand_less</span></button>
		<h3 i18n>Store filter</h3>
		<div class="filter collapser">
			<fieldset>
				<legend i18n>Pickup or Delivery</legend>
				${LebeledInput.create('<label for="filterPickupRb" i18n>Pickup</label>', `<input type="radio" id="filterPickupRb" name="filterDelivery" ${!this._isLocalStorageDelivery() ? 'checked' : ''}>`, true)}
				${LebeledInput.create('<label for="filterDeliveryRb" i18n>Delivery</label>', `<input type="radio" id="filterDeliveryRb" name="filterDelivery" ${this._isLocalStorageDelivery() ? 'checked' : ''}>`, true)}
			</fieldset>
			<div id="filterDliveryAddressForm" ${!this._isLocalStorageDelivery() ? 'hidden' : ''}>
				<fieldset id="filterDeliveryAddress">
					<legend i18n>Delivery Address</legend>
					${LebeledInput.create('<label for="filterDeliveryStreet" required i18n>Street</label>', `<input id="filterDeliveryStreet" class="address-helper" value="${localStorage.getItem('deliveryStreet')}">`, false)}
					${LebeledInput.create('<label for="filterDeliveryNr" required i18n>Nr.</label>', `<input id="filterDeliveryNr" class="address-helper" value="${localStorage.getItem('deliveryNr')}">`, false)}
					${LebeledInput.create('<label for="filterDeliveryPostalCode" required i18n>Postal Code</label>', `<input id="filterDeliveryPostalCode" class="address-helper" type="number" value="${localStorage.getItem('deliveryPostalCode')}">`, false)}
					${LebeledInput.create('<label for="filterDeliveryCity" required i18n>City</label>', `<input id="filterDeliveryCity" class="address-helper" value="${localStorage.getItem('deliveryCity')}">`, false)}
					${LebeledInput.create('<label for="filterDeliveryCountry" required i18n>Country</label>', `<input id="filterDeliveryCountry" autocomplete="new-password" value="${localStorage.getItem('deliveryCountry') ? localStorage.getItem('deliveryCountry') : 'DE'}">`, false, null, null, { hidden: null })}
				</fieldset>
			</div>
			<fieldset id="filterTimeSelector"></fieldset>
			<fieldset>
				<legend i18n>Bigger order</legend>
				${LebeledInput.create(`<label for="filterImmediatelyRb" >${I18N.translateAndFormat('Over {0}€', 50)}</label>`, `<input type="checkbox" id="filterOver50Eur" ${Number(localStorage.getItem('expectedOrderValue')) >= 50 ? 'checked' : ''}>`, true)}
			</fieldset>
		</div>`

		document.getElementById('filterPickupRb').addEventListener('change', ev => {
			if (ev.target.checked) {
				this._setDelivery('pickup')
				this._orderSchedule.setDeliveryType('pickup')
				this._orderSchedule.init()
			}
		})
		document.getElementById('filterDeliveryRb').addEventListener('change', ev => {
			if (ev.target.checked) {
				this._setDelivery('delivery')
				this._orderSchedule.setDeliveryType('delivery')
				this._orderSchedule.init()
			}
		})

		document.getElementById('filterOver50Eur').addEventListener('change', ev => {
			if (ev.target.checked) {
				this._setExpectedOrderValue(50)
			}
			else {
				this._setExpectedOrderValue(10)
			}
		})

		// Add the AddressHelper
		const addressHelper = new AddressHelper()
		addressHelper.addAddressHelper(document.getElementById('filterDeliveryPostalCode'), document.getElementById('filterDeliveryCity'), document.getElementById('filterDeliveryStreet'), document.getElementById('filterDeliveryNr'), () => {
			localStorage.setItem('deliveryStreet', document.getElementById('filterDeliveryStreet').value)
			localStorage.setItem('deliveryNr', document.getElementById('filterDeliveryNr').value)
			localStorage.setItem('deliveryPostalCode', document.getElementById('filterDeliveryPostalCode').value)
			localStorage.setItem('deliveryCity', document.getElementById('filterDeliveryCity').value)
			localStorage.setItem('deliveryCountry', document.getElementById('filterDeliveryCountry').value)
			this._onSetFilterHandlers.forEach(handler => handler(this._createFilter()))
		})

		if (this._collapsed) {
			this._onSetFilterHandlers.forEach(handler => handler())
		}
		else {
			this._onSetFilterHandlers.forEach(handler => handler(this._createFilter()))
		}

		this._target.querySelectorAll('.toggleBtn').forEach(toggleBtn => toggleBtn.addEventListener('click', () => {
			this.expand(this._collapsed)
			if (this._collapsed) {
				this._onSetFilterHandlers.forEach(handler => handler(null))
			}
			else {
				this._onSetFilterHandlers.forEach(handler => handler(this._createFilter()))
			}
		}))

		this._orderSchedule = new OrderSchedule('filterTimeSelector')

		I18N.translateElement(this._target)
	}

	setStores = stores => this._stores = stores

	setVisible = visible => {
		if (visible) {
			if (this._isLocalStorageDelivery()) {
				this._setDelivery('delivery')
				document.getElementById('filterPickupRb').removeAttribute('checked')
				document.getElementById('filterDeliveryRb').setAttribute('checked', '')
				this._orderSchedule.setDeliveryType('delivery')
			}
			else {
				this._setDelivery('pickup')
				document.getElementById('filterDeliveryRb').removeAttribute('checked')
				document.getElementById('filterPickupRb').setAttribute('checked', '')
				this._orderSchedule.setDeliveryType('pickup')
			}
			this._orderSchedule.setSchedule(this._getLocalStorageSchedule())
			this._orderSchedule.setStores(this._stores)
			this._orderSchedule.addSetExpandedHandlers(expand => this.expand(expand))
			this._orderSchedule.addOnSetOrderScheduleHandlers(schedule => {
				this._schedule = schedule
				this._setLocalStorageSchedule(schedule)
				this._onSetFilterHandlers.forEach(handler => handler(this._createFilter()))
			})
			this._orderSchedule.init()
		}
	}

	addOnSetFilterHandlers = (...onSetFilterHandlers) => this._onSetFilterHandlers.push(...onSetFilterHandlers)

	expand = expanded => {
		if (expanded) {
			this._target.classList.add('expanded')
			this._target.classList.remove('collapsed')
			this._collapsed = false
		}
		else {
			this._target.classList.remove('expanded')
			this._target.classList.add('collapsed')
			this._collapsed = true
		}
	}

	_setDelivery = delivery => {
		const isDelivery = delivery === 'delivery'
		this._setLocalStorageDelivery(isDelivery)
		if (isDelivery) {
			document.getElementById('filterDliveryAddressForm').removeAttribute('hidden')
		}
		else {
			document.getElementById('filterDliveryAddressForm').setAttribute('hidden', '')
		}
		this._onSetFilterHandlers.forEach(handler => handler(this._createFilter()))
	}

	_setExpectedOrderValue = value => {
		localStorage.setItem('expectedOrderValue', value)
		this._onSetFilterHandlers.forEach(handler => handler(this._createFilter()))
	}

	_createFilter = () => {
		const filter = {}
		if (this._isLocalStorageDelivery()) {
			filter.deliveryAddress = {
				street: localStorage.getItem('deliveryStreet'),
				nr: localStorage.getItem('deliveryNr'),
				postalCode: localStorage.getItem('deliveryPostalCode'),
				city: localStorage.getItem('deliveryCity'),
				country: localStorage.getItem('deliveryCountry')
			}
		}
		if (this._schedule) {
			filter.schedule = {
				now: false,
				date: this._schedule
			}
		}
		else {
			filter.schedule = {
				now: true,
				date: new Date()
			}
		}
		if (Number(localStorage.getItem('expectedOrderValue')) >= 50) {
			filter.expectedValueOver = Number(localStorage.getItem('expectedOrderValue'))
		}
		return filter
	}

	_getLocalStorageSchedule = () => {
		if (localStorage.getItem('scheduled') !== 'true') {
			return null
		}
		else {
			const localStorageSchedule = localStorage.getItem('schedule')
			return new Date(localStorageSchedule)

		}
	}

	_setLocalStorageSchedule = scheduleDate => {
		if (!scheduleDate) {
			localStorage.setItem('scheduled', false)
			localStorage.removeItem('schedule')
		}
		else {
			localStorage.setItem('schedule', DateHelper.getIsoFormatOfDateTime(scheduleDate))
			localStorage.setItem('scheduled', true)
		}
	}

	_isLocalStorageDelivery = () => localStorage.getItem('delivery') === 'delivery'

	_setLocalStorageDelivery = delivery => {
		if (delivery) {
			localStorage.setItem('delivery', 'delivery')
		}
		else {
			localStorage.setItem('delivery', 'pickup')
		}
	}

}